import {
    Button, Grid, Tooltip, Typography,
} from '@mui/material';
import React from 'react';
import { getJsonPath } from '../../utils/constants';
import { getStringFromObject } from '../../utils/lodash';

type Props = {
    error: Error,
};

const ErrorFallBackComponent = (props: Props) => {
    const { error } = props;
    return (
        <Grid container marginTop={4} className="ErrorFallBack">
            <Grid item sm={6}>
                <img src={getJsonPath('/Error/bug.svg')} alt="error" />
            </Grid>
            <Grid
                container
                item
                sm={6}
                md={6}
                lg={6}
                flexDirection="column"
                alignContent="center"
                justifyContent="center"
            >
                <Grid item>
                    <Tooltip title={getStringFromObject('message', error) as string} placement="left">
                        <Typography variant="h4" textAlign="center">
                            An Error Occurred
                        </Typography>
                    </Tooltip>
                </Grid>
                <Button onClick={() => { window.location.reload(); }}>
                    Click Here To Reload Page
                </Button>
            </Grid>
        </Grid>
    );
};

export default ErrorFallBackComponent;
